"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    jwtItems: ()=>jwtItems
});
const cloud_api_config_namespaceObject = require("@bytecloud/cloud-api-config");
const mapValues_namespaceObject = require("lodash/mapValues");
var mapValues_default = /*#__PURE__*/ __webpack_require__.n(mapValues_namespaceObject);
const row_js_namespaceObject = require("../aegis-api-config/row.js");
const ttp_js_namespaceObject = require("../aegis-api-config/ttp.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function jwt_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else jwt_config_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const defaultFetchTimeout = 8000;
const domainIDItems = mapValues_default()(cloud_api_config_namespaceObject.allCloudApiConfigs, function(item) {
    return {
        baseUrl: `${item.jwt}/v1`,
        fetchTimeout: defaultFetchTimeout
    };
});
const jwtItems = _object_spread_props(_object_spread({}, domainIDItems), {
    'cn-byted': {
        baseUrl: row_js_namespaceObject.rowApiConfig.cnBytedJwt,
        fetchTimeout: defaultFetchTimeout
    },
    'local-test': {
        baseUrl: row_js_namespaceObject.rowApiConfig.localTestJwt,
        fetchTimeout: defaultFetchTimeout
    },
    'i18n-byteintl': {
        baseUrl: row_js_namespaceObject.rowApiConfig.i18nByteIntlJwt,
        fetchTimeout: defaultFetchTimeout
    },
    'i18n-byted': {
        baseUrl: row_js_namespaceObject.rowApiConfig.i18nByted,
        fetchTimeout: defaultFetchTimeout
    },
    'cn-ttp-row': {
        baseUrl: row_js_namespaceObject.rowApiConfig.cnTTPRoWJwt,
        fetchTimeout: defaultFetchTimeout
    },
    'ttp-row-org': {
        baseUrl: row_js_namespaceObject.rowApiConfig.ttpRowOrg,
        fetchTimeout: defaultFetchTimeout
    },
    'sinf-bytedance': {
        baseUrl: row_js_namespaceObject.rowApiConfig.sinfBytedance,
        fetchTimeout: defaultFetchTimeout
    },
    'ttp-us-row': {
        baseUrl: ttp_js_namespaceObject.ttpJwtConfig.ttpUsRow,
        fetchTimeout: defaultFetchTimeout
    },
    'cn-byteintl': {
        baseUrl: row_js_namespaceObject.rowApiConfig.cnByteintl,
        fetchTimeout: defaultFetchTimeout
    },
    'i18n-eu-net': {
        baseUrl: ttp_js_namespaceObject.ttpJwtConfig["i18n-eu-net"],
        fetchTimeout: defaultFetchTimeout
    },
    'i18n-eu-org': {
        baseUrl: ttp_js_namespaceObject.ttpJwtConfig["i18n-eu-org"],
        fetchTimeout: defaultFetchTimeout,
        skipDowngradeCheck: true
    },
    'ttp-us-org': {
        baseUrl: ttp_js_namespaceObject.ttpJwtConfig["ttp-us-org"],
        fetchTimeout: defaultFetchTimeout
    },
    'ttp-us-row-org': {
        baseUrl: ttp_js_namespaceObject.ttpJwtConfig["ttp-us-row-org"],
        fetchTimeout: defaultFetchTimeout
    }
});
exports.jwtItems = __webpack_exports__.jwtItems;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "jwtItems"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
